import Repository from '@/repositories/marketing'
const resource = '/analytics/custom_reports'

export default {
  fetch(config) {
    return Repository.get(`${resource}.json`, config)
  },
  show(reportId, config) {
    return Repository.get(`${resource}/${reportId}.json`, config)
  },
  delete(reportId, config) {
    return Repository.delete(`${resource}/${reportId}.json`, config)
  },
  update(reportId, payload ,config) {
    return Repository.put(`${resource}/${reportId}.json`, payload ,config)
  },
  create(payload, config) {
    return Repository.post(`${resource}.json`, payload ,config)
  },
  fetchNewReport(config) {
    return Repository.get(`${resource}/new.json`, config)
  },
  fetchSavedReport(reportId, config) {
    return Repository.get(`${resource}/${reportId}/edit.json`, config)
  },
  fetchDuplicateData(reportId, config) {
    return Repository.get(`${resource}/${reportId}/duplicate.json`, config)
  },
  fetchCampaigns(config) {
    return Repository.get(`${resource}/search_campaign.json`, config)
  },
  toggleRecurrence(reportId, config) {
    return Repository.put(`${resource}/${reportId}/toggle_enabled`,config)
  },
  fetchLists(config) {
    return Repository.get(`${resource}/search_list.json`, config)
  },
  fetchSMSCampaigns(config) {
    return Repository.get(`${resource}/search_sms_campaign.json`, config)
  },
  updatedReportInfo(reportId, config) {
    return Repository.get(`${resource}/${reportId}/info.json`, config)
  },
  fetchOneTimeCampaigns(payload,config){
    return Repository.post(`${resource}/search_campaigns_for_one_time_report.json`, payload,config);
  },
  getCampaignsCount(payload){
    return Repository.post(`${resource}/get_campaigns_count.json`, payload)
  }
}
